export default "__VITE_ASSET__BwOUXAUl__"